import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { AppInformationService, ArkUnitOfWork, AuthService } from '../../core/core.module';
import _ from 'lodash';

@Component({
    selector: 'app-proposal-vote-dialog',
    templateUrl: './proposal-vote-dialog.component.html',
    styleUrls: ['./proposal-vote-dialog.component.scss'],
    standalone: false,
})
export class ProposalVoteDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    proposal: any;
    vote: any;
    voteValue: any;
    values = ['Yes', 'No'];
    committees: any;
    saving = false;
    yesVotes: number = 0;
    yesPercentage: number = 0;
    noVotes: number = 0;
    noPercentage: number = 0;
    readOnly = false;

    constructor(public modalRef: BsModalRef, private uow: ArkUnitOfWork, private appInfo: AppInformationService, public auth: AuthService) {}

    async ngOnInit() {
        this.committees = this.uow.lookups.committees;
        this.readOnly = this.proposal.approved || this.proposal.declined;
        const vote = await this.uow.getVoteByUserId(this.auth.currentUser.id, this.proposal.id);
        if (!vote) {
            this.vote = this.uow.proposalVotes.createEntity();
            this.vote.proposalId = this.proposal.id;
            this.vote.created = new Date();
            this.vote.userId = this.auth.currentUser.id;
            this.vote.createdBy = this.auth.currentUser.userName;
        } else {
            this.vote = vote;
            this.voteValue = this.vote.yesVote ? 'Yes' : 'No';
        }
        this.proposal.proposalVotes.forEach((x) => {
            this.yesVotes += x.yesVote ? 1 : 0;
            this.noVotes += x.noVote ? 1 : 0;
        });
        const totalVotes = this.yesVotes + this.noVotes;
        this.yesPercentage = Number(((this.yesVotes / totalVotes)*100).toFixed(2));
        this.noPercentage = Number(((this.noVotes / totalVotes)*100).toFixed(2));
    }
    async save() {
        // console.log(this.voteValue);
        if (!this.voteValue || (this.voteValue !== 'Yes' && this.voteValue !== 'No')) return;
        this.saving = true;

        if (this.voteValue === 'Yes') {
            this.vote.yesVote = true;
            this.vote.noVote = false;
        }
        if (this.voteValue === 'No') {
            this.vote.yesVote = false;
            this.vote.noVote = true;
        }
        await this.uow.commit();
        this.result.next({ success: true });
    }

    close() {
        this.uow.rollback();
        this.result.next(false);
    }
}
